import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        "flex h-9 w-full rounded-lg border border-border bg-surface-elevated px-3 py-1 text-sm text-foreground transition-colors",
        "placeholder:text-text-dim",
        "focus-visible:border-primary-mid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-mid",
        "disabled:cursor-not-allowed disabled:opacity-60",
        "read-only:cursor-default read-only:opacity-75",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
